// @flow
import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

// Route Wrapper Components
import PublicWithNavbarRoute from "./RouteWrappers/PublicWithNavbarRoute";
import PublicRoute from "./RouteWrappers/PublicRoute";

// Error Pages Container Components
import ErrorPageContainer from "../Containers/HelperPages/ErrorPageContainer";

// Public Pages Container Components
import LandingPageContainer from "../Containers/PublicPages/LandingPageContainer";
import AboutPageContainer from "../Containers/PublicPages/AboutPageContainer";
import ContactPageContainer from "../Containers/PublicPages/ContactPageContainer";
import InventoryCountProcessPageContainer from "../Containers/PublicPages/InventoryCountProcessPageContainer";
import HrSolutionsPageContainer from "../Containers/PublicPages/HrSolutionsPageContainer";

// Public Account Pages Container Components
import InitialRequestPageContainer from "../Containers/PublicAccountPages/InitialRequestPageContainer";
import LoginPageContainer from "../Containers/PublicAccountPages/LoginPageContainer";
import CompanyRegisterPageContainer from "../Containers/PublicAccountPages/CompanyRegisterPageContainer";
import UserRegisterPageContainer from "../Containers/PublicAccountPages/UserRegisterPageContainer";

type PropsType = {};
type StateType = {};

class MainRoutes extends Component<PropsType, StateType> {
  render() {
    return (
      <Switch>
        <PublicWithNavbarRoute
          exact
          path="/"
          component={LandingPageContainer}
        />
        <PublicWithNavbarRoute
          exact
          path="/hakkimizda"
          component={AboutPageContainer}
        />
        <PublicWithNavbarRoute
          exact
          path="/iletisim"
          component={ContactPageContainer}
        />
        <PublicWithNavbarRoute
          exact
          path="/envanter-sayim"
          component={InventoryCountProcessPageContainer}
        />
        <PublicWithNavbarRoute
          exact
          path="/ik-cozumleri"
          component={HrSolutionsPageContainer}
        />
        {/* <PublicRoute
          exact
          path="/kayit-ol"
          component={InitialRequestPageContainer}
        />
        <PublicRoute exact path="/giris" component={LoginPageContainer} />
        <PublicRoute
          exact
          path="/:type/:request_secret/firma-hesap-aktivasyonu"
          component={CompanyRegisterPageContainer}
        />
        <PublicRoute
          exact
          path="/:request_id/:related_secret/kullanici-hesap-aktivasyonu"
          component={UserRegisterPageContainer}
        /> */}
        <Route component={ErrorPageContainer} />
      </Switch>
    );
  }
}

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/Routes/MainRoutes.js